// Ebbrest: блок «Complete your night» (sections/eb-complete.liquid). Автор «каталог и допы», 12.10.2026.
//
// Что делает:
// 1. Считает сумму: цена выбранной версии героя плюс цены отмеченных допов. Скидки нет, это простая сумма.
// 2. Версию героя читает из карточек blocks/eb-size-cards.liquid на той же странице: атрибут data-eb-pending
//    и отмеченные карточки версии и комплекта. Сам вариант героя не выбирает никогда.
//    Пока версия не выбрана, кнопка называется «Choose a version» и прокручивает к карточкам.
// 3. По кнопке кладёт героя и отмеченные допы в корзину ОДНИМ запросом Ajax Cart API (POST /cart/add.js, items)
//    и тем же запросом просит разметку секций корзины. Перерисовывает корзину сама Horizon: скрипт отправляет
//    её штатное событие CartLinesUpdateEvent с обещанием, как это делают assets/eb-cart.js и product-form.js темы.
//
// Чего не делает: сам в корзину ничего не добавляет без нажатия, галочки допов за покупателя не ставит,
// fetch темы не перехватывает и разметку корзины руками не трогает.
//
// Ключей из .env не берёт. Подключается с defer из самой секции. Повторное подключение безвредно.
// Диагностика: ?eb_debug=1 в адресе пишет шаги в консоль.
//
// Не проверено (12.10.2026): на витрине не запускался. Проверены синтаксис и логика на подставной странице
// (расчёт суммы, смена версии, тело запроса, порядок позиций).
(function () {
  'use strict';
  if (window.__ebComplete) return;
  window.__ebComplete = true;

  var DEBUG = /[?&]eb_debug=1/.test(location.search);
  var FALLBACK_ERROR = 'Could not add these items. Please try again.';
  var states = [];

  function log() {
    if (!DEBUG || !window.console) return;
    console.log.apply(console, ['[eb-complete]'].concat([].slice.call(arguments)));
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function routes() {
    var r = (window.Theme && window.Theme.routes) || {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return { add: r.cart_add_url || root + 'cart/add.js', cart: r.cart_url || root + 'cart' };
  }

  // Формат денег магазина ("${{amount}}", "€{{amount_with_comma_separator}}" и так далее). Копейки-нули срезаются,
  // как у фильтра money_without_trailing_zeros в разметке.
  function group(n, sep) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }
  function money(cents, format) {
    cents = Math.round(Number(cents) || 0);
    var whole = Math.floor(Math.abs(cents) / 100);
    var frac = ('0' + (Math.abs(cents) % 100)).slice(-2);
    var sign = cents < 0 ? '-' : '';
    function amount(thousands, decimal, decimals) {
      var s = sign + group(decimals ? whole : Math.round(Math.abs(cents) / 100), thousands);
      return decimals && frac !== '00' ? s + decimal + frac : s;
    }
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(format || '');
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = amount(',', '.', false); break;
      case 'amount_with_comma_separator': value = amount('.', ',', true); break;
      case 'amount_no_decimals_with_comma_separator': value = amount('.', ',', false); break;
      case 'amount_with_apostrophe_separator': value = amount("'", '.', true); break;
      case 'amount_no_decimals_with_space_separator': value = amount(' ', ',', false); break;
      case 'amount_with_space_separator': value = amount(' ', ',', true); break;
      case 'amount_with_period_and_space_separator': value = amount(' ', '.', true); break;
      default: value = amount(',', '.', true);
    }
    var out = m ? format.replace(m[0], value) : value;
    // формат может содержать теги (<span class=money>): в текст они не нужны
    return out.replace(/<[^>]*>/g, '');
  }

  // Карточки версии героя на этой же странице. Ищем заново при каждом расчёте: тема перерисовывает секцию товара.
  function cardsRoot(st) {
    var id = st.root.getAttribute('data-product-id');
    var all = document.querySelectorAll('[data-eb-size-cards]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].hasAttribute('data-eb-off')) continue;
      if (!id || all[i].getAttribute('data-product-id') === id) return all[i];
    }
    return null;
  }

  function checkedCard(cards, name) {
    var inputs = cards.querySelectorAll('input[data-eb-card="' + name + '"]');
    for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) return inputs[i].value;
    return null;
  }

  function variantById(st, id) {
    for (var i = 0; i < st.data.variants.length; i++) {
      if (String(st.data.variants[i].id) === String(id)) return st.data.variants[i];
    }
    return null;
  }

  // Возвращает { variant, pending, cards }. pending: версия не выбрана, в корзину героя класть нельзя.
  function heroState(st) {
    var cards = cardsRoot(st);
    if (cards) {
      if (cards.getAttribute('data-eb-pending') === 'true') return { variant: null, pending: true, cards: cards };
      var model = checkedCard(cards, 'model');
      var setup = cards.getAttribute('data-eb-setup-option') ? checkedCard(cards, 'setup') : null;
      if (model === null) return { variant: null, pending: true, cards: cards };
      for (var i = 0; i < st.data.variants.length; i++) {
        var v = st.data.variants[i];
        if (v.options.indexOf(model) < 0) continue;
        if (setup !== null && v.options.indexOf(setup) < 0) continue;
        return { variant: v, pending: false, cards: cards };
      }
      return { variant: null, pending: true, cards: cards };
    }
    // Карточек нет. Единственный вариант или вариант из адреса берём, иначе выбор за покупателем на странице героя.
    if (st.data.single && st.data.variants.length) return { variant: st.data.variants[0], pending: false, cards: null };
    var fromUrl = /[?&]variant=(\d+)/.exec(location.search);
    var chosen = fromUrl ? variantById(st, fromUrl[1]) : null;
    return { variant: chosen, pending: !chosen, cards: null };
  }

  function checkedItems(st) {
    var out = [];
    var inputs = st.root.querySelectorAll('[data-eb-complete-item]');
    for (var i = 0; i < inputs.length; i++) {
      if (!inputs[i].checked) continue;
      out.push({ id: Number(inputs[i].value), price: Number(inputs[i].getAttribute('data-price')) || 0 });
    }
    return out;
  }

  // Что уже лежит в корзине. Нужно, чтобы не положить героя второй раз: покупатель мог добавить его
  // штатной кнопкой выше и прийти сюда только за допами. null: корзина ещё не прочитана.
  var cartIds = null;
  var cartAt = 0;
  function readCart() {
    return request(routes().cart + '.js').then(function (cart) {
      cartIds = (cart.items || []).map(function (item) { return String(item.variant_id || item.id); });
      cartAt = Date.now();
      return cart;
    });
  }
  function refreshCart(force) {
    if (!window.fetch || !window.Promise) return;
    if (!force && Date.now() - cartAt < 3000) return;
    cartAt = Date.now();
    readCart().then(updateAll, function () {});
  }
  // Штатная форма товара: когда её отправили последний раз и сколько запросов блока сейчас в работе.
  var NATIVE_WAIT = 2500;
  var nativeAt = 0;
  var busy = 0;
  function heroInCart(st) {
    return !!(st.hero && cartIds && cartIds.indexOf(String(st.hero.id)) >= 0);
  }

  function setText(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  function update(st) {
    if (!st.root.isConnected) return;
    var hero = heroState(st);
    watchCards(st, hero.cards);
    var items = checkedItems(st);
    var total = hero.variant ? hero.variant.price : 0;
    for (var i = 0; i < items.length; i++) total += items[i].price;

    var soldOut = !!hero.variant && !hero.variant.available;
    st.pending = hero.pending;
    st.hero = hero.variant;
    // Герой уже в корзине: кнопка добавляет только допы, сумма это сумма допов.
    var inCart = heroInCart(st);
    if (inCart) total -= hero.variant.price;
    st.blocked = soldOut && !inCart;
    var nothing = inCart && !items.length;

    var line = st.root.querySelector('[data-eb-complete-hero-line]');
    var price = st.root.querySelector('[data-eb-complete-hero-price]');
    var totalNode = st.root.querySelector('[data-eb-complete-total]');
    var label = st.root.querySelector('[data-eb-complete-label]');
    var button = st.root.querySelector('[data-eb-complete-submit]');
    var fmt = st.data.money;

    if (hero.variant) {
      var title = st.data.single ? '' : hero.variant.title;
      setText(line, inCart ? (title ? title + ' · ' : '') + st.labels.incart : title);
      setText(price, money(hero.variant.price, fmt));
      setText(totalNode, nothing ? '' : money(total, fmt));
      if (inCart) setText(label, nothing ? st.labels.addons : st.labels.addons + ' · ' + money(total, fmt));
      else setText(label, soldOut ? st.labels.sold : st.labels.add + ' · ' + money(total, fmt));
    } else {
      setText(line, st.labels.pending);
      // Наименьшая цена среди версий для выбранного комплекта, как в блоке покупки (writePrice в eb-buy.js):
      // иначе при Both sides без версии на странице стояли бы две разные суммы «From».
      var low = st.data.priceMin;
      var varies = st.data.priceVaries;
      var setupNow = hero.cards && hero.cards.getAttribute('data-eb-setup-option') ? checkedCard(hero.cards, 'setup') : null;
      if (setupNow !== null) {
        var seen = null;
        var differ = false;
        for (var k = 0; k < st.data.variants.length; k++) {
          var cand = st.data.variants[k];
          if (cand.options.indexOf(setupNow) < 0) continue;
          if (seen !== null && cand.price !== seen) differ = true;
          if (seen === null || cand.price < seen) seen = cand.price;
        }
        if (seen !== null) { low = seen; varies = differ; }
      }
      var from = varies && st.labels.from ? st.labels.from + ' ' : '';
      setText(price, from + money(low, fmt));
      // Сумму без версии героя не показываем: число было бы неполным.
      setText(totalNode, '');
      setText(label, st.labels.choose);
    }
    if (button) {
      if (st.blocked || nothing) button.setAttribute('aria-disabled', 'true');
      else button.removeAttribute('aria-disabled');
    }
    var totalRow = totalNode ? totalNode.parentNode : null;
    if (totalRow) totalRow.hidden = !hero.variant || nothing;
  }

  // Следим за атрибутом data-eb-pending карточек: его ставит assets/eb-buy.js после выбора версии.
  function watchCards(st, cards) {
    if (st.watched === cards) return;
    if (st.observer) st.observer.disconnect();
    st.watched = cards;
    if (!cards || !window.MutationObserver) return;
    st.observer = new MutationObserver(function () { schedule(st); });
    st.observer.observe(cards, { attributes: true, attributeFilter: ['data-eb-pending', 'data-eb-off'] });
  }

  function schedule(st) {
    if (st.queued) return;
    st.queued = true;
    setTimeout(function () {
      st.queued = false;
      update(st);
    }, 0);
  }

  function showError(st, text) {
    var box = st.root.querySelector('[data-eb-complete-error]');
    if (!box) return;
    box.textContent = text || '';
    box.hidden = !text;
  }

  function goToCards(st) {
    var cards = cardsRoot(st);
    if (!cards) {
      // Карточек версии нет (или eb-buy.js их выключил). На странице самого героя переходить некуда:
      // прокручиваем к штатному выбору варианта. На адрес героя уходим только с чужой страницы.
      var url = st.root.getAttribute('data-eb-hero-url');
      var here = false;
      try { here = !!url && new URL(url, location.href).pathname === location.pathname; } catch (e) {}
      if (url && !here) { location.assign(url); return; }
      var picker = document.querySelector('variant-picker, .variant-picker, product-form-component, .product-details');
      if (picker) {
        try { picker.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' }); }
        catch (e) { picker.scrollIntoView(); }
        var field = picker.querySelector('input, select, button');
        if (field && field.focus) field.focus({ preventScroll: true });
      }
      return;
    }
    var target = cards.querySelector('[data-eb-group="model"]') || cards;
    try {
      target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
    } catch (e) {
      target.scrollIntoView();
    }
    var first = cards.querySelector('input[data-eb-card="model"]');
    if (first && first.focus) first.focus({ preventScroll: true });
  }

  function sectionIds() {
    var ids = [];
    [].forEach.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids;
  }

  function request(url, body) {
    var options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    return fetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        log(body ? 'POST' : 'GET', url, response.status);
        if (!response.ok || (data && data.status && data.message)) {
          var error = new Error((data && (data.description || data.message)) || FALLBACK_ERROR);
          error.ebCart = true;
          throw error;
        }
        return data;
      });
    });
  }

  // Модуль стандартных событий Shopify из importmap темы. Грузится вставкой <script type="module">:
  // Shopify при сжатии ассета переписывает import() в классическом скрипте на require() (мина из README темы).
  var eventsModule = null;
  function loadEvents() {
    if (eventsModule) return eventsModule;
    eventsModule = new Promise(function (resolve) {
      var done = false;
      function finish(mod) {
        if (done) return;
        done = true;
        resolve(mod && mod.CartLinesUpdateEvent ? mod : null);
      }
      try {
        window.__ebCompleteEvents = finish;
        var tag = document.createElement('script');
        tag.type = 'module';
        tag.textContent = "import * as m from '@shopify/events'; window.__ebCompleteEvents && window.__ebCompleteEvents(m);";
        tag.onerror = function () { finish(null); };
        document.head.appendChild(tag);
        setTimeout(function () { finish(null); }, 4000);
      } catch (e) {
        finish(null);
      }
    });
    return eventsModule;
  }

  // Позиции запроса. Герой идёт последним: позиция, добавленная позже, встаёт в корзине выше (не проверено на витрине).
  // Героя не кладём, если этот же вариант уже в корзине: иначе покупатель получит два комплекта.
  function buildItems(st) {
    var items = checkedItems(st).map(function (item) { return { id: item.id, quantity: 1 }; });
    if (!heroInCart(st)) items.push({ id: st.hero.id, quantity: 1 });
    return items;
  }

  function submit(st) {
    update(st);
    if (st.pending || !st.hero) {
      goToCards(st);
      return;
    }
    if (st.blocked) return;
    var button = st.root.querySelector('[data-eb-complete-submit]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    var form = st.root.querySelector('[data-eb-complete-form]');
    var r = routes();
    var ids = sectionIds();
    var items = [];
    var heroAdded = false;
    button.setAttribute('aria-busy', 'true');
    showError(st, '');

    function release() {
      if (button.isConnected) button.removeAttribute('aria-busy');
    }

    // Гонка со штатной кнопкой «Add to cart» (правка 12.10.2026). Если её нажали только что, запрос темы мог ещё
    // не записать героя в корзину: ждём, пока с её отправки пройдёт NATIVE_WAIT, и только потом читаем корзину.
    var wait = Math.max(0, NATIVE_WAIT - (Date.now() - nativeAt));
    busy += 1;
    function free() { busy = Math.max(0, busy - 1); }
    new Promise(function (resolve) { setTimeout(resolve, wait); }).then(function () {
      // Корзину читаем прямо перед добавлением: по ней решается, класть ли героя. Не прочиталась: кладём как выбрано.
      return readCart().catch(function () {});
    }).then(function () {
      update(st);
      items = buildItems(st);
      heroAdded = items.some(function (item) { return String(item.id) === String(st.hero.id); });
      if (!items.length) return null;
      return loadEvents();
    }).then(function (mod) {
      if (!items.length) return;
      var deferred = null;
      if (mod) {
        deferred = mod.CartLinesUpdateEvent.createPromise();
        deferred.promise.catch(function () {});
        form.dispatchEvent(new mod.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: items.map(function (item) { return { merchandiseId: String(item.id), quantity: item.quantity }; }),
          promise: deferred.promise
        }));
      }

      var body = { items: items };
      if (ids.length) {
        body.sections = ids.join(',');
        body.sections_url = location.pathname;
      }

      return request(r.add, body).then(function (added) {
        if (!mod) {
          log('no events module, opening the cart page');
          location.assign(r.cart);
          return;
        }
        return readCart().then(function (cart) {
          // Страховка от той же гонки на медленной сети: штатная кнопка нажата недавно, героя клали и мы, и в корзине
          // его стало больше одного. Лишний комплект снимаем, покупатель просил один.
          if (!heroAdded || Date.now() - nativeAt > 20000) return cart;
          var line = null;
          (cart.items || []).forEach(function (item) { if (String(item.variant_id) === String(st.hero.id) && item.quantity > 1) line = item; });
          if (!line) return cart;
          log('hero added twice, removing one');
          return request(r.cart + '/change.js', { id: line.key, quantity: line.quantity - 1 }).then(readCart, function () { return cart; });
        }).then(function (cart) {
          log('added', items, 'sections', Object.keys(added.sections || {}));
          deferred.resolve({
            cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              sections: added.sections || undefined,
              items: cart.items,
              itemCount: cart.item_count,
              source: 'eb-complete',
              didError: false
            }
          });
          // Галочки снимаем: отмеченное уже в корзине, повторное нажатие не должно удвоить допы незаметно.
          [].forEach.call(st.root.querySelectorAll('[data-eb-complete-item]'), function (input) { input.checked = false; });
          update(st);
        });
      }).catch(function (error) {
        log('failed', String(error));
        if (deferred) deferred.reject(error);
        showError(st, error && error.ebCart && error.message ? error.message : st.labels.error);
      });
    }).then(function () { free(); release(); }, function () { free(); release(); });
  }

  function init(root) {
    if (root.__ebComplete) return;
    var data;
    try {
      data = JSON.parse(root.querySelector('[data-eb-complete-data]').textContent);
    } catch (e) {
      return;
    }
    if (!data || !data.variants || !data.variants.length) return;
    root.__ebComplete = true;
    var st = {
      root: root,
      data: data,
      labels: {
        add: root.getAttribute('data-eb-label-add') || 'Add selected to cart',
        choose: root.getAttribute('data-eb-label-choose') || 'Choose a version',
        addons: root.getAttribute('data-eb-label-addons') || 'Add selected add-ons',
        incart: root.getAttribute('data-eb-label-incart') || 'Already in your cart',
        sold: root.getAttribute('data-eb-label-sold') || 'Sold out',
        pending: root.getAttribute('data-eb-label-pending') || '',
        error: root.getAttribute('data-eb-label-error') || FALLBACK_ERROR,
        from: root.getAttribute('data-eb-from') || ''
      },
      pending: true,
      hero: null,
      blocked: false,
      queued: false,
      watched: undefined,
      observer: null
    };
    states.push(st);

    // Вариант допа с выбором: id и цена галочки берутся из выбранной строки списка.
    root.addEventListener('change', function (event) {
      var select = event.target;
      if (!select || !select.matches || !select.matches('[data-eb-complete-variant]')) return;
      var row = select.closest('.eb-complete__row');
      var input = row && row.querySelector('[data-eb-complete-item]');
      var option = select.options[select.selectedIndex];
      if (!input || !option) return;
      input.value = option.value;
      input.setAttribute('data-price', option.getAttribute('data-price') || '0');
      setText(row.querySelector('[data-eb-complete-item-price]'), money(option.getAttribute('data-price'), data.money));
    });

    // Корзина могла измениться штатной кнопкой выше: перечитываем, когда покупатель дошёл до блока.
    root.addEventListener('pointerdown', function () { refreshCart(false); }, { passive: true });
    root.addEventListener('focusin', function () { refreshCart(false); });

    update(st);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-eb-complete]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
    if (states.length && cartIds === null && !cartAt) refreshCart(true);
  }

  function updateAll() {
    for (var i = states.length - 1; i >= 0; i--) {
      if (!states[i].root.isConnected) {
        if (states[i].observer) states[i].observer.disconnect();
        states.splice(i, 1);
        continue;
      }
      schedule(states[i]);
    }
  }

  // Любая смена галочки, карточки версии или варианта темы: пересчитать. Тема шлёт свои события позже,
  // поэтому считаем сразу и ещё раз после её запроса секции.
  document.addEventListener('change', function () {
    updateAll();
    setTimeout(updateAll, 600);
  });
  window.addEventListener('pageshow', function () {
    updateAll();
    if (states.length) refreshCart(true);
  });

  // Штатная форма товара на этой же странице. Пока блок сам кладёт героя, её отправку держим: иначе в корзине
  // окажутся два комплекта. Во всех остальных случаях только запоминаем время отправки (см. submit).
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    if (form.closest('product-card, quick-add-dialog') || !states.length) return;
    if (event.defaultPrevented) return;
    if (busy > 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
      log('native add held: the block is adding the set');
      return;
    }
    nativeAt = Date.now();
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-eb-complete-form]')) return;
    // У формы нет action (см. sections/eb-complete.liquid): без скрипта блок скрыт, обычной отправки у неё нет.
    event.preventDefault();
    if (!window.fetch || !window.Promise) return;
    for (var i = 0; i < states.length; i++) {
      if (states[i].root.contains(form)) {
        submit(states[i]);
        return;
      }
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Для проверки на подставной странице.
  window.__ebCompleteTest = { money: money, heroState: heroState, buildItems: buildItems, setCart: function (ids) { cartIds = ids; updateAll(); } };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
})();
